// Hero figures (2026-10-26, heroes3d): the heroes with a model of their own, and the center's giant. Meshy 6 from model
// sheets in the ops repo (concept/h3d), each in its army's look (ROSTER.md). Kept apart from premium.ts, which loads the
// armies: a figure is loaded the first time its hero takes the field (main.ts), from units/heroes/<id>.glb.
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import type { HeroId } from '../sim/defs';
import { BakedArmy, type Baked } from './baked';
import { BODY, FACE, bakeUnit, type Face } from './premium';

/** Each hero with its own model (the file is <id>.glb), and its face, measured as premium.ts FACE's are (bind-pose
 *  renders with guides every 0.01 of the rest height; tall props are in the box: Joan's banner, Liang's bun, Leonidas's
 *  crest; under a helmet, the skull). Musashi and Tomoe have none: they draw as the Samurai elite and rider, their look
 *  class. */
export const FIGURE = {
  // joan, liang, wallace, lagertha and cuauhtemoc re-made on the chunky build (armies2, 2026-10-26); Wallace's chin is
  // his jaw, not his beard's tip. Lagertha's hair is her head (STYLE Canon): her chin is her jaw and her top the hair's
  // (anatomy canon, 2026-11-01; it had stopped at twice her eyes, under the hair, and drew her at 2.6 heads)
  joan: { chin: 0.648, eyes: 0.78 }, liang: { chin: 0.713, eyes: 0.815 }, leonidas: { chin: 0.593, eyes: 0.699 },
  wallace: { chin: 0.69, eyes: 0.818 }, lagertha: { chin: 0.66, eyes: 0.80, top: 0.995 }, cuauhtemoc: { chin: 0.707, eyes: 0.844 },
  giant: { chin: 0.708, eyes: 0.818 },
} satisfies Partial<Record<HeroId | 'giant', Face>>;
export type FigureId = keyof typeof FIGURE;
export const FIGURES = Object.keys(FIGURE) as FigureId[];
Object.assign(FACE, FIGURE); // so proportion() sizes each figure's head to the army's share

/** A figure baked for at most a few on the field (heroes PLAYERS, the giant one); they cast the sun's shadow. */
export interface PremiumFigure { draw: BakedArmy; scale: number; baked: Baked }

export async function loadFigure(dir: string, id: FigureId, cap: number): Promise<PremiumFigure> {
  const baked = bakeUnit(id, await new GLTFLoader().setMeshoptDecoder(MeshoptDecoder).loadAsync(`${dir}/${id}.glb`));
  return { draw: new BakedArmy(baked, cap, true), scale: BODY.hero / baked.height, baked };
}
